import ScalarLoading_vue_vue_type_script_setup_true_lang_default from "./ScalarLoading.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                  */
import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
//#region src/components/ScalarLoading/ScalarLoading.vue
var ScalarLoading_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ScalarLoading_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-27df5cd8"]]);
//#endregion
export { ScalarLoading_default as default };

//# sourceMappingURL=ScalarLoading.vue.js.map